import { render } from "./client-tasks-tab.vue?vue&type=template&id=13751d5e"
import script from "./client-tasks-tab.vue?vue&type=script&lang=js"
export * from "./client-tasks-tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__